import React, { useState, useEffect, useRef } from 'react';
import {
  IconDots, IconWhatsApp, IconChatLines,
} from 'gatorcomponents';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import useLocale from '@/hooks/useLocale';
import { OPERACOES_HEADER_WHATSAPP_CHAT } from '@/config/GrowthBook/constants';
import { tierSupportIds } from '../../HeaderV2.enum';
import * as Styles from './TierSupportDropdown.styles';

export const TierSupportDropdown = ({ onChatClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  const enableWhatsAppChat = useFeatureIsOn(OPERACOES_HEADER_WHATSAPP_CHAT);
  const { template: templateLocale } = useLocale();
  const { supportDropdown } = templateLocale;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleChatClick = () => {
    setIsOpen(false);
    onChatClick();
  };

  const handleToggle = () => {
    if (!enableWhatsAppChat) {
      onChatClick();
      return;
    }
    setIsOpen(prev => !prev);
  };

  const handleWhatsAppClick = () => {
    setIsOpen(false);
    window.open('https://wa.me/554898124658', '_blank');
  };

  return (
    <Styles.Wrapper ref={wrapperRef} data-testid="tier-support-dropdown">
      <Styles.TriggerButton onClick={handleToggle} data-testid="tier-support-trigger">
        <IconDots color="lowDark" />
      </Styles.TriggerButton>

      {isOpen && (
        <Styles.DropdownMenu data-testid="tier-support-menu">
          <Styles.DropdownItem
            onClick={handleChatClick}
            data-testid={tierSupportIds.chat}
          >
            <IconChatLines color="lowDark" />
            {supportDropdown.chatLabel}
          </Styles.DropdownItem>

          {enableWhatsAppChat && (
            <Styles.DropdownItem
              onClick={handleWhatsAppClick}
              data-testid={tierSupportIds.whatsapp}
            >
              <IconWhatsApp color="lowDark" />
              {supportDropdown.whatsappLabel}
            </Styles.DropdownItem>
          )}
        </Styles.DropdownMenu>
      )}
    </Styles.Wrapper>
  );
};
